import { BankOutlined } from "@ant-design/icons";
import { Modal } from "antd";
import React from "react";
import { useDisclosure } from "../../../../../../hooks/useDisclosure";
import { AppButton } from "../../../../../atoms/Button";
import { PopupTitle } from "../../../../../atoms/Popup";
import { FinancialDimensionsForm } from "../../../../../organism";

type FinancialDimensionsProps = {
  propertyId?: string;
  unitId?: string;
  propertyFinancialDimensions?: Record<string, unknown>;
  onSubmitSuccess?: () => void;
};

export const FinancialDimensions = (props: FinancialDimensionsProps) => {
  const { onSubmitSuccess, propertyId, unitId, propertyFinancialDimensions } = props;
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <AppButton size="large" onClick={onOpen} icon={<BankOutlined />}>
        Financial Dimensions
      </AppButton>
      <Modal
        centered
        width="50%"
        footer={null}
        open={isOpen}
        title={<PopupTitle title="Financial Dimensions" />}
        destroyOnClose={true}
        onCancel={onClose}
        maskClosable={false}
      >
        <FinancialDimensionsForm
          isOpen={isOpen}
          onClose={onClose}
          onSubmitSuccess={onSubmitSuccess}
          propertyId={propertyId}
          unitId={unitId}
          propertyFinancialDimensions={propertyFinancialDimensions}
          screen="property"
        />
      </Modal>
    </>
  );
};
